import semAcesso from '../assets/images/CGD-Pensoes-Erro-634x539.png';

const NoLogin = (props) => {

  return (
    <div className="container">
      {props.showInvalid && (
        <div className="d-flex justify-content-center">
          <div className="d-flex flex-column align-items-start">
            <img src={semAcesso} className="w-100 mt-5" />
            <p className="mt-3 ms-2">
              Necessita de ajuda? <a href="/ajuda">Fale connosco.</a>
            </p>
          </div>
        </div>
      )}
      {!props.showInvalid && (
        <div className="col-md-12">
          <h1 className="text-center my-5 py-5">
            Por favor inicie a sua sessão
          </h1>
        </div>
      )}
    </div>
  );
};

export default NoLogin;
